<div class="measure-control">
    <div class="mapboxgl-ctrl-group mapboxgl-ctrl">
        <button class="mapbox-gl-draw_ctrl-draw-btn mapbox-gl-draw_line" title="Đo chiều dài"
            (click)="measureLength()"></button>
        <button class="mapbox-gl-draw_ctrl-draw-btn mapbox-gl-draw_polygon" title="Đo diện tích"
            (click)="measureArea()"></button>
        <button class="mapbox-gl-draw_ctrl-draw-btn mapbox-gl-draw_trash" title="Xoá" (click)="clear()"></button>
    </div>
</div>